@if (label()) {
  <ng-template #tag>
    <p-tag
      [severity]="severity()"
      [value]="label() ?? undefined"
      [icon]="icon()"
      [class]="customClass()"
      [pTooltip]="tooltip()"
    ></p-tag>
  </ng-template>

  @if (url()) {
    <button type="button" class="cursor-pointer border-0 bg-transparent p-0" (click)="goTo(url())">
      <ng-container [ngTemplateOutlet]="tag" />
    </button>
  } @else {
    <ng-container [ngTemplateOutlet]="tag" />
  }
}
